<template>
  <div>
    <div class="columns is-gapless is-vcentered is-border-bottom has-bg-light is-min-height-50"
          v-if="history && history.length">
      <div class="column is-padding-left is-padding-right">
        <span>
          Dernière intéraction avec le contact
          <b>{{history[0].date|prettyDate}}</b>
          à {{history[0].date|prettyTime}}
        </span>
      </div>
    </div>
    <div class="has-bg-white">
      <div class="columns is-gapless is-multiline is-border-top"
            v-for="(h, i) in sortedHistory" :key="i"
            :class="{'has-bg-light':i % 2}">
        <div class="column is-narrow is-padding has-vertical-separator">
          <div class="is-margin-top-xsmall">
            <span class="avatar is-medium">
              <span class="has-text-white" :class="h.color"><i class="fa-lg" :class="h.icon"></i></span>
            </span>
          </div>
        </div>
        <div class="column is-padding">
          <div class="has-text-grey is-size-6">création : {{h.date | date}}</div>
          <div>
            <b v-if="h.type === 'RDV'" class="is-uppercase">{{h.rdvType}} avec {{h.sellerName}} le 
              <router-link :to="{name: 'ContactRdv', params: {id: sourceContact.pk}}">
                <a class="is-underline">{{h.moment}}</a>
              </router-link>
            </b>
            <b v-else class="is-uppercase">{{h.typeName}}</b>
            <b class="is-uppercase" v-if="h.type === 'HISTORY'">{{h.info}}</b>
            <span class="has-text-grey" v-if="h.sellerName"> - Vendeur : </span>
            <router-link :to="{name: 'UserVue', params: {id: h.seller}}" v-if="h.sellerName">
              <b class="is-uppercase">{{h.sellerName}}</b>
            </router-link>
            <span class="has-text-grey" v-if="h.companyName"> - Société : </span>
            <router-link :to="{name: 'CompanyVue', params: {id: h.company}}" v-if="h.companyName">
              <b class="is-uppercase">{{h.companyName}}</b>
            </router-link>
          </div>
          <div v-if="h.reportN1 || h.reportN2">
            <p v-if="h.reportN1">{{h.contactName}} est <b>{{h.reportN1}}.</b></p>
            <p v-if="h.reportN2">{{h.reportN1 === '' ? '' : 'Information'}}: <b>{{h.reportN2}}</b>.</p>
          </div>
          <div v-else-if="h.deferred">Le rendez-vous est <b>Reporté</b>.</div>
          <div v-else-if="h.type === 'RDV'" class="has-text-danger is-italic is-underline is-size-6">Bilan RDV en attente</div>
          <div v-if="h.advRef">
            <router-link :to="{name: 'AdvInfos', params: {id: h.advPk}}" class="has-text-grey is-underline is-size-5">
              <span>Ref ADV : <b>{{h.advRef}}</b></span>
            </router-link>
          </div>
          <div class="has-text-grey is-size-6">
            <span v-if="h.lotName">Lot : 
              <router-link :to="{name: 'LotVue', params: {id: h.lot}}" class="is-uppercase"><b>{{h.lotName}}</b></router-link>
            </span>
            <span v-if="h.lotName && h.programName"> - </span>
            <span v-if="h.programName">Programme : 
              <router-link :to="{name: 'ProgramVue', params: {id: h.program}}" class="is-uppercase"><b>{{h.programName}}</b></router-link>
            </span>
          </div>
          <div class="has-text-grey is-size-7 is-margin-top-xxsmall">
            <i><span v-if="h.author">Par {{h.author}} </span><b>le {{h.date | date}} à {{h.date | prettyTime}}</b></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import { DefaultValues } from '@/mixins'

  export default {
    name: 'ContactHistory',
    mixins: [DefaultValues],
    props: {
      sourceHistory: {
        type: Array,
        default: () => []
      },
      sourceOptions: {
        type: Array,
        default: () => []
      },
      sourceRdvs: {
        type: Array,
        default: () => []
      },
      sourceSales: {
        type: Array,
        default: () => []
      },
      sourceDenunciations: {
        type: Array,
        default: () => []
      },
      sourceContact: {
        type: Object,
        required: true
      }
    },
    computed: {
      history () {
        return this.sourceHistory.filter(x => {
          return x.tag === 'HISTORY'
        }).map(x => {
          return {
            date: x.created_on,
            type: x.tag,
            info: x.info,
            typeName: null,
            color: 'has-bg-dark',
            icon: 'fal fa-users-cog',
            author: x.update_author_name
          }
        })
      },
      options () {
        return this.sourceOptions.map(x => {
          return {
            date: x.created_on,
            type: 'OPTION',
            typeName: 'Option',
            color: 'has-bg-optionne',
            icon: 'fal fa-flag',
            seller: x.seller,
            sellerName: x.seller_name,
            company: x.company,
            companyName: x.company_name,
            lot: x.lot,
            lotName: x.lot_ref,
            program: x.program,
            programName: x.program_name,
            hasBadge: false,
            author: x.update_author_name
          }
        })
      },
      denunciations () {
        return this.sourceDenunciations.filter(x => x.status === 'approved').map(x => {
          return {
            date: x.created_on,
            type: 'DENONCIATION',
            typeName: 'Dénonciation',
            color: 'has-bg-optionne',
            icon: 'fal fa-flag',
            seller: x.seller,
            sellerName: x.seller_name,
            company: x.company,
            companyName: x.company_name,
            lot: x.lot,
            lotName: x.lot_ref,
            program: x.program,
            programName: x.program_name,
            author: x.update_author_name
          }
        })
        // return denuncation.filter(x => x.status === 'approved')
      },
      rdvs () {
        return this.sourceRdvs.map(x => {
          let reportN1 = x.reports.length ? this.calendarReports.find(y => y.type === x.reports[0].type) : null
          let reportN2 = x.reports.length > 1 ? this.calendarReports.find(y => y.type === x.reports[1].type) : null
          return {
            deferred: x.deferred,
            date: x.created_on,
            type: 'RDV',
            rdvType: x.rdv_type,
            dateInit: x.date,
            moment: moment(x.date).format('DD/MM/YYYY'),
            sellerName: x.seller_name,
            typeName: `${x.rdv_type} avec ${x.seller_name} le ${moment(x.date).format('DD/MM/YYYY')}`,
            color: 'has-bg-rdv',
            icon: 'far fa-calendar-alt',
            hasBadge: true,
            badgeStatus: '',
            reportN1: reportN1 ? reportN1.label : null,
            reportN2: reportN2 ? reportN2.label : null,
            contactName: x.contact_name,
            author: x.update_author_name
          }
        })
      },
      sales () {
        return this.sourceSales.map(x => {
          let type = 'SALE'
          let typeName = 'Vente actée'
          let color = 'has-bg-annonce'
          let icon = 'fas fa-award'
          if (x.status === 'reserved') {
            type = 'SALE_RESERVATION'
            typeName = 'Réservation'
            color = 'has-bg-reserve'
            icon = 'fas fa-file-certificate'
          }
          if (x.status.includes('canceled')) {
            type = 'SALE_CANCELED'
            typeName = 'Réservation annulée'
            color = 'has-bg-black'
            icon = 'fas fa-file-certificate'
          }
          return {
            date: x.reservation_date,
            type,
            typeName: typeName,
            color: color,
            icon: icon,
            seller: x.seller,
            sellerName: x.seller_name,
            company: x.company,
            companyName: x.company_name,
            lot: x.lot,
            lotName: x.lot_ref,
            program: x.program,
            programName: x.program_name,
            advRef: x.ref,
            advPk: x.pk,
            author: x.update_author_name
          }
        })
      },
      sortedHistory () {
        let items = this.options.concat(this.rdvs, this.sales, this.denunciations, this.history)
        return items.sort((a, b) => {
          return moment(b.date).format('x') - moment(a.date).format('x')
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/contact/ContactRightPanel/ContactHistory.vue